import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export interface SystemConfigResponse {
  id: number
  configKey: string
  configName: string
  configValue: string
  configType: string
  configGroup: string
  description: string
  status: number
  sortOrder: number
  remark: string
}

export const systemConfigApi = defineApi('operation', ({ prefix }) => {
  /**
   * 根据 key 获取配置
   * @param key - 配置的 key，例如 'system.default_password'
   * @returns 配置信息
   */
  function getConfigByKey(key: string) {
    return requestClient
      .get<SystemConfigResponse>(prefix(`config/key/${key}`))
      .then((res: any) => {
        return {
          configValue: res?.configValue,
        }
      })
  }

  return {
    getConfigByKey,
  }
})
